import { createApp } from "vue";
import { createPinia } from "pinia";
import App from "./app/App.vue";
import { i18n } from "./app/translations";
import VueMatomo from "vue-matomo";
import { getMatomoConfiguration } from "./app/matomo/configuration";
import { trackPageView } from "./app/matomo/tracking";

const pinia = createPinia();
const app = createApp(App);

const matomoConfiguration = getMatomoConfiguration();

app.use(i18n);
app.use(pinia);
app.use(VueMatomo, matomoConfiguration);

app.mount("#app");

trackPageView();
